export default __webpack_public_path__ + "static/media/shelf (spring 2010).dc0b3d89.JPG";